var _Skeleton, _div;
import { cx } from 'class-variance-authority';
import { Skeleton } from '@crehana/compass.ui';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CourseCardSkeleton = function CourseCardSkeleton() {
  return /*#__PURE__*/_jsxs("div", {
    className: cx('tw-w-full tw-min-h-28 tw-h-full tw-rounded-2 tw-overflow-hidden tw-min-w-24',
    // Border
    'tw-border tw-border-solid tw-border-neutral-light-400 dark:tw-border-neutral-dark-600'),
    children: [_Skeleton || (_Skeleton = /*#__PURE__*/_jsx(Skeleton, {
      animated: true,
      className: "tw-w-full tw-min-h-21.2"
    })), _div || (_div = /*#__PURE__*/_jsxs("div", {
      className: "tw-p-1.2",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        animated: true,
        className: "tw-w-7.2 tw-h-2.4 tw-rounded-2 tw-mb-1.6"
      }), /*#__PURE__*/_jsx(Skeleton, {
        animated: true,
        className: "tw-w-full tw-h-1.2 tw-rounded-2 tw-mb-0.4"
      }), /*#__PURE__*/_jsx(Skeleton, {
        animated: true,
        className: "tw-w-11.2 tw-h-1.2 tw-rounded-2 tw-mb-1.6"
      }), /*#__PURE__*/_jsxs("div", {
        className: "tw-flex tw-items-center",
        children: [/*#__PURE__*/_jsx(Skeleton, {
          className: "tw-w-8 tw-h-2 tw-mr-1 tw-rounded-2",
          animated: true
        }), /*#__PURE__*/_jsx(Skeleton, {
          className: "tw-w-8 tw-h-2 tw-rounded-2",
          animated: true
        })]
      })]
    }))]
  });
};
export default CourseCardSkeleton;